/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    RelationshipType,
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * A referral code that is used for tracking the onboarding of users.
 * @export
 * @interface ReferralCode
 */
export interface ReferralCode {
    /**
     * 
     * @type {string}
     * @memberof ReferralCode
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ReferralCode
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralCode
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralCode
     */
    code: string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof ReferralCode
     */
    relationshipType: RelationshipType;
}

export function ReferralCodeFromJSON(json: any): ReferralCode {
    return ReferralCodeFromJSONTyped(json, false);
}

export function ReferralCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'code': json['code'],
        'relationshipType': RelationshipTypeFromJSON(json['relationshipType']),
    };
}

export function ReferralCodeToJSON(value?: ReferralCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'code': value.code,
        'relationshipType': RelationshipTypeToJSON(value.relationshipType),
    };
}


